(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`._header_m076r_1{z-index:3;background-color:#fff}._header_container_m076r_6{margin-bottom:2px}._neu-image_wrapper_m076r_10{max-width:100%;height:auto}._neu_image_wrapper_m076r_15{display:flex;align-items:center}@media (max-width: 576px){._neu_image_wrapper_m076r_15{justify-content:center;width:100%}}._neu_image_wrapper_m076r_15 .neu-image{margin:0 auto}
._top_navigation_container_br4ci_1{white-space:nowrap}._neu-dropdown_br4ci_5:hover{padding:var(--neu-spacer-2, 4px);border-radius:50%;color:var(--neu-blue-60)}._dropdown_items_br4ci_11{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._dropdown_items_active_br4ci_16{background-color:var(--link-pressed-background, #6a91af)}@media (max-width: 993px){._dropdown_container_br4ci_21{display:none}}@media (min-width: 993px){._mobile_menu_br4ci_27{display:none}}
._mhoTabsWrapper_1vsck_1{display:grid;grid-template-columns:1fr;gap:var(--neu-spacer-6, 24px);align-items:start;margin-top:var(--neu-spacer-3, .5rem)}@media (min-width: 768px){._mhoTabsWrapper_1vsck_1{gap:var(--neu-spacer-7, 32px);grid-template-columns:224px 1fr}}@media (min-width: 992px){._mhoTabsWrapper_1vsck_1{grid-template-columns:312px 1fr}}._mhoTabsWrapper_1vsck_1 ._noBackgroundTab_1vsck_19{background:none;box-shadow:none!important}._mhoTabsWrapper_1vsck_1 ._minH320_1vsck_23{min-height:320px}._mhoTabsWrapper_1vsck_1.neu-list{box-shadow:var(--neu-elevation-1) var(--neu-elevation-color)}
._certificationImageContainer_1gn0m_1{display:flex;justify-content:end;align-items:center;width:100%}@media (max-width: 660px){._certificationImageContainer_1gn0m_1{justify-content:center;width:100%;height:72px}}._certificationImageContainer_1gn0m_1>button>figure{margin:0}._imageContainer_1gn0m_19>figure{margin:0}._certificationButton_1gn0m_23{padding:var(--neu-spacer-0);background-color:transparent;min-width:auto;min-height:auto;border:none;text-align:center;cursor:pointer}._certificationButton_1gn0m_23:active,._certificationButton_1gn0m_23:focus,._certificationButton_1gn0m_23:hover{transform:scale(1.2);transition:transform .3s ease-in-out;background-color:transparent}._certificationButton_1gn0m_23:focus-visible{outline:revert;background-color:transparent}._modal_wrapper_3fxo4_1{max-height:600px}._modal_header_3fxo4_5{text-align:center}._modal_description_3fxo4_9{padding-top:20px;text-align:left;line-height:26px}._modal_description_3fxo4_9>p{line-height:26px}._modal_description_3fxo4_9>ul>li::marker{font-size:1.5em;font-weight:700}._modal_description_3fxo4_9>ul{padding-left:22px}._modal_image_3fxo4_28{width:200px}._footerSection_96jav_1{padding:70px 0 30px;background-color:#fff}@media (max-width: 768px){._footerSection_96jav_1{padding:30px var(--neu-spacing-0, 0px)}}._footerContainer_96jav_11{padding:var(--neu-spacing-0, 0) var(--neu-spacing-4, 12px);display:grid;grid-template-columns:1fr 1fr;grid-template-areas:"contact privacy" "links links"}@media (min-width: 1400px){._footerContainer_96jav_11{max-width:1320px}}@media (max-width: 660px){._footerContainer_96jav_11{align-items:center;grid-template-columns:1fr;grid-template-areas:"contact" "links" "privacy";place-items:center}}._contactArea_96jav_31{grid-area:contact}._logoImageContainer_96jav_35{display:flex;justify-content:start;padding-bottom:10px}@media (max-width: 660px){._logoImageContainer_96jav_35{justify-content:center;padding-bottom:var(--neu-spacing-6, 20px)}}._logoImageContainer_96jav_35>figure{margin:var(--neu-spacing-0, 0px)}._contactInfo_96jav_51{text-wrap:balance;text-align:center}@media (min-width: 768px){._contactInfo_96jav_51{text-align:start}}._linkArea_96jav_61{grid-area:links;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:center;padding-block:var(--neu-spacing-6, 20px);gap:var(--neu-spacing-6, 20px)}@media (min-width: 1024px){._linkArea_96jav_61{justify-content:start}}@media (max-width: 660px){._linkArea_96jav_61{flex-direction:column;align-items:center;gap:10px}}._privacyArea_96jav_84{grid-area:privacy;display:grid;grid-template-areas:"certification-image" "privacy-info"}@media (min-width: 1024px){._privacyArea_96jav_84{column-gap:20px;grid-template-columns:1fr max-content;grid-template-areas:"privacy-info certification-image"}}@media (max-width: 660px){._privacyArea_96jav_84{column-gap:20px;align-items:center}}._privacyInfoContainer_96jav_103{grid-area:privacy-info;display:flex;flex-direction:column;align-items:end;padding-top:var(--neu-spacing-1, 2px)}@media (max-width: 660px){._privacyInfoContainer_96jav_103{padding:var(--neu-spacing-6, 20px);align-items:center;text-align:center}}@media (min-width: 1024px){._privacyInfoContainer_96jav_103{justify-content:center}}._privacyInfo_96jav_103{text-wrap:balance;text-align:center}@media (min-width: 768px){._privacyInfo_96jav_103{text-align:end}}
._mho_alert_wrapper_1lqun_1 .neu-snackbar{--snackbar-radius: 0}
._table_usmlv_1 th{border-top:none;padding:var(--neu-spacing-4, .75rem) 0 var(--neu-spacing-3, .5rem)}._table_usmlv_1 th:not(:last-of-type){width:50%}@media (min-width: 360px){._table_usmlv_1 th:not(:last-of-type){width:60%}}@media (min-width: 576px){._table_usmlv_1 th:not(:last-of-type){width:70%}}@media (min-width: 992px){._table_usmlv_1 th:not(:last-of-type){width:37.5%}}@media (min-width: 1200px){._table_usmlv_1 th:not(:last-of-type){width:40%}}@media (max-width: 480px){._table_usmlv_1 th:not(:last-of-type) h3{white-space:normal!important}}._table_usmlv_1 td{padding:var(--neu-spacing-4, .75rem) 0;max-width:0}._table_usmlv_1 td p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._table_usmlv_1 tr:last-of-type>td{border-bottom:none}._table_usmlv_1 tfoot{border-top:1px solid var(--table-border)}@media (max-width: 992px){._table_usmlv_1 th{padding:var(--neu-spacing-1, .125rem) 0}._table_usmlv_1 td{padding:var(--neu-spacing-3, .5rem) 0}}._table_usmlv_1 tbody tr:hover :is(th,td){background:var(--table-background)!important}._description_usmlv_64 p,._item_usmlv_65 p{margin:0}._description_usmlv_64>td,._item_usmlv_65>td{border-top:none}._item_usmlv_65>td:first-of-type{max-width:75px}@media (min-width: 576px){._item_usmlv_65>td:first-of-type{max-width:85px}}@media (min-width: 992px){._item_usmlv_65>td:first-of-type{max-width:110px}}._item_usmlv_65>td:last-of-type{width:auto;max-width:none}._description_usmlv_64>td{padding-top:0}._headerRowWithDescription_usmlv_99 th{padding:0;border-bottom:none}._headerRowWithDescription_usmlv_99+tr>td{padding:0;padding-bottom:var(--neu-spacing-3, .5rem);border-top:none}
._formInput_tgf87_1 button{text-align:left}._divider_23elx_1{width:100%;height:1px}
._card_items_1xzq2_1{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._card_items_1xzq2_1:hover,._card_items_1xzq2_1:focus{background-color:var(--neu-gray-10, #e2e2e2)}._card_items_1xzq2_1:active{background-color:var(--neu-blue-10, #d3e5f2)}@media (min-width: 768px){._card_items_1xzq2_1._header_link_1xzq2_12{display:none}}._link_icon_container_1xzq2_17{width:var(--neu-spacer-6, 1.5rem);text-align:center}._link_icon_container_1xzq2_17>figure{margin:0}._userEmail_std5a_1{text-overflow:ellipsis;max-width:284px}._profileCardContainer_std5a_6{padding-left:1.5rem}._profileCardContainer_std5a_6 .neu-dropdown--menu{max-width:284px!important;transform:translate3d(2px,23px,0)!important}@media (max-width: 660px){._profileCardContainer_std5a_6 .neu-dropdown--menu{inset:0px 0px auto auto;transform:translate3d(4px,23px,0)}}._profileCardContainer_std5a_6 .neu-dropdown--menu ul{max-height:none!important}._profileCardContainer_std5a_6 .neu-dropdown--menu li,._profileCardContainer_std5a_6 .neu-dropdown--menu a{width:284px!important}._profileCardContainer_std5a_6 .neu-dropdown--menu a:hover{color:var(--neu-gray-100)}._firstName_std5a_31{font-size:20px!important;text-overflow:ellipsis;max-width:284px}
._description_35t4d_1 p{margin:0}@media (min-width: 768px){._addLinkForm-input1_35t4d_6{width:33%}}@media (min-width: 768px){._addLinkForm-input2_35t4d_12{width:66%}}._disclaimerText_35t4d_17{line-height:1.125rem}
._formInput_ffgvo_1{display:flex;align-items:center;width:var(--custom-width, 100%)}._card_1b673_1{width:100%;aspect-ratio:3/1.8;border:3px dashed rgb(var(--neu-gray-10-light, 226, 226, 226));background-color:rgb(var(--neu-plain-0-light, 255, 255, 255));border-radius:var(--neu-border-radius-default, 8px);overflow:hidden}._card_1b673_1:has(input:focus){border-color:rgb(var(--neu-gray-20-light, 226, 226, 226))}@media (min-width: 769px){._card_1b673_1{max-height:220px}}._icon_1b673_18{font-size:2.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin-bottom:10px}._cardTitletext_1b673_24{font-size:1.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin:0;padding:5px 0}@media (max-width: 576px){._cardTitletext_1b673_24{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._description_1b673_39{font-size:var(--neu-font-size, 1rem);color:rgb(var(--neu-gray-10-dark, 31, 31, 31));margin:0}@media (max-width: 576px){._description_1b673_39{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._alertError_1b673_53{padding:var(--neu-spacer-4, .75rem);text-align:center;margin-top:var(--neu-spacer-5, 1rem);position:relative}._uploadedImageWrapper_1b673_60{width:100%;height:100%}._uploadedImage_1b673_60{width:100%;height:100%;position:relative;transform:translate(-50%,-50%);top:50%;left:50%}._uploadedImage_1b673_60 figure{width:100%;height:100%;margin:0}._uploadedImage_1b673_60 figure div{height:100%;width:100%}._uploadedImage_1b673_60 figure img{width:100%;height:100%;object-fit:contain}._reuploadMessage_1b673_88{position:absolute;bottom:0;left:0;color:#fff!important;background:#00000080;width:100%;text-align:center;padding:5px 0;display:none!important;z-index:10}._uploadedContainer_1b673_101{position:relative;width:100%;height:100%}._uploadedContainer_1b673_101:focus,._uploadedContainer_1b673_101:hover>div._reupload_message_1b673_106{display:block!important}._fileInput_1b673_110{height:1px;width:1px;opacity:0;position:absolute}
._formItem_r52t0_1{flex:1}
._linkField_kas8y_1{min-width:fit-content;padding-top:var(--neu-spacing-2, .25rem)}._text_field_1gmpc_1 p{margin:0}@media (max-width: 768px){._image_field_1gmpc_7{height:6.25rem;width:6.25rem}}._divider_h91qf_1{height:1px;transform:translateY(-21px)}
._modalContentContainer_10hs1_1{max-height:90vh;overflow:auto}@media (max-width: 475px){._modalContentContainer_10hs1_1{max-height:85vh}}
._description_1nfzp_1 p{margin:0}._searchItem_1nfzp_5{background-color:var(--neu-plain-0, #fff)}._noItemErrorMessage_1nfzp_9 ul li::marker{color:var(--neu-plain-100, #000)}
._horizontalTabsWrapper_lulv0_1{display:flex;width:100%}._horizontalTabsWrapper_lulv0_1 .unit-tab{flex:1 1 0;min-width:0;align-items:center;justify-content:center}._horizontalTabsWrapperSc_lulv0_12{padding-left:0;padding-right:0}._horizontalTabsCard_lulv0_17 .unit-content{padding:0}
._imageContainer_1xsj3_1{margin:16px 0;position:relative;min-height:104px;min-width:104px;height:fit-content;width:fit-content}._editButton_1xsj3_10{position:absolute;bottom:0;right:0;background-color:var(--neu-gray-10, "#e2e2e2")!important}._fileInput_1xsj3_17{width:1px;height:1px;display:none}._formItemPreferredFacilityState_1eisr_1{width:100%!important;min-width:50%!important;flex:1}@media screen and (min-width: 960px){._formItemPreferredFacilityState_1eisr_1{flex:.2;max-width:140px!important;min-width:140px!important}}._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{width:100%!important;padding-right:24px!important}@media screen and (max-width: 380px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:265px!important}}@media screen and (min-width: 381px) and (max-width: 575px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:305px!important}}@media screen and (min-width: 576px) and (max-width: 820px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:196px!important}}@media screen and (min-width: 821px) and (max-width: 1024px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:320px!important}}`)),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsxs as h, jsx as n, Fragment as B } from "react/jsx-runtime";
import { useRef as ue, useEffect as Z, useState as A, useCallback as S, useMemo as D } from "react";
import { useI18n as x } from "next-localization";
import { o as de, s as R, a as he, u as fe, M as pe } from "../../chunks/types.BJMlOVBS.js";
import { u as ge } from "../../chunks/use-is-auth-token-generated.BkMrw8To.js";
import { NeuModal as y, NeuIcon as ye, NeuButton as L, NeuFeedback as H, NeuAlertContextual as Pe, NeuCard as ee, NeuSnackbar as Ce } from "@hcahealthcaredpx/neutron-react";
import { u as oe } from "../../chunks/emulation-provider.CUxwy5Cg.js";
import { B as be } from "../../chunks/button-link.BSk7JXpT.js";
import { i as Ne, P as Me } from "../../chunks/page-content.B0ugSU6N.js";
import { M as w } from "../../chunks/modifiable-list.C-OdvAIi.js";
import { RichText as q, Text as Se, withDatasourceCheck as Ie } from "@sitecore-jss/sitecore-jss-nextjs";
import { useForm as Re } from "react-hook-form";
import { g as xe, r as Ee } from "../../chunks/sessions-api.CDuxaXsQ.js";
import { useMutation as K, useQueryClient as Q } from "@tanstack/react-query";
import { c as ae, d as ve, e as De } from "../../chunks/use-account.DkVfV1FC.js";
import { q as V } from "../../chunks/stale.constant.De1PuSBj.js";
import { R as z, F as we, a as Oe } from "../../chunks/form-mask-input.92EW49hv.js";
import { F as Fe } from "../../chunks/form-date-picker.LFmaEfS6.js";
import { F as v, a as ne, b as te } from "../../chunks/form-wrapper.CxSd-0ur.js";
import { getFormattedDate as ke } from "../../utils/date-time/index.js";
import { u as Ae } from "../../chunks/use-accounts-relation-types.BZfXDW3J.js";
import { useRouter as re } from "next/router";
import { u as Le, A as qe } from "../../chunks/use-events-message-publish.CEtxSWTq.js";
import { createEmulationCookieProxy as Ve } from "../../utils/emulation/index.js";
import { u as Be } from "../../chunks/useModal.DSDGkQa1.js";
import { M as Te } from "../../chunks/mho-action-buttons.fY1B40h9.js";
const _e = (e) => {
  const t = ue();
  Z(() => {
    !t.current && e && (t.current = {
      mainUser: {
        user: { ...e.user },
        contacts: e == null ? void 0 : e.contacts,
        dependentRelationships: e == null ? void 0 : e.dependentRelationships
      }
    });
  }, [e]), Z(() => {
    var s;
    typeof window < "u" && t.current && window.localStorage.setItem(
      "mainUser",
      JSON.stringify(((s = t.current) == null ? void 0 : s.mainUser) || {})
    );
  }, [e]);
}, Ue = (e) => K({
  ...e,
  mutationFn: xe
}), $e = ({
  name: e,
  title: t,
  mhoId: s,
  isOpen: a,
  close: o
}) => {
  var P, l, N;
  const f = re(), { t: u } = x(), c = Q(), m = oe(), { data: i } = ae({ queryParams: { levelOfDetail: "IDENTITY" } }), d = ((P = i == null ? void 0 : i.user) == null ? void 0 : P.myHealthOneId) ?? "", p = `${(l = i == null ? void 0 : i.user) == null ? void 0 : l.firstName} ${(N = i == null ? void 0 : i.user) == null ? void 0 : N.lastName}`, { mutate: g } = Le(), { mutate: b } = Ue({
    onSuccess: async () => {
      g({
        topic: "CWD_MHO_USER_ACTIVITY",
        message: {
          mhoId: s,
          category: "NONCLINICAL",
          data: {
            activityTypeId: qe.ProxyStart,
            userMyHealthOneId: s,
            actorId: d,
            actorTypeId: 1
          }
        }
      }), Ve(d, p), m == null || m.setEmulation({
        isEmulating: !0,
        actorId: d,
        actorName: p,
        agentId: void 0
      }), c.clear(), await c.refetchQueries({ queryKey: ["csrf"] }), f.push("/home");
    }
  });
  return /* @__PURE__ */ h(
    y,
    {
      backdropDismiss: !0,
      label: `${t} ${e}`,
      size: "medium",
      active: a,
      onNeuDismiss: o,
      children: [
        /* @__PURE__ */ n(y.Content, { children: /* @__PURE__ */ h("div", { className: "d-flex align-items-center gap-3", children: [
          /* @__PURE__ */ n("span", { className: "d-block", children: u("Mho.Profie.ManageRelationshipsProxy.Labels.You") }),
          /* @__PURE__ */ n(ye, { name: "arrow_forward", size: "2x", color: "blue-60" }),
          /* @__PURE__ */ n("span", { className: "d-block", children: e })
        ] }) }),
        /* @__PURE__ */ n(y.Footer, { children: /* @__PURE__ */ h("div", { className: "d-flex w-100 flex-column-reverse gap-3 flex-sm-row justify-content-sm-end", children: [
          /* @__PURE__ */ n(L, { kind: "tertiary", onNeuClick: o, children: u("Mho.Profie.ManageRelationshipsProxy.Labels.Cancel") }),
          /* @__PURE__ */ n(L, { onNeuClick: () => b({ userId: s, actorId: d }), children: u("Mho.Profie.ManageRelationshipsProxy.Labels.BeginProxy") })
        ] }) })
      ]
    }
  );
}, Ge = ({
  isOpen: e,
  onClose: t,
  infoModalTitle: s,
  infoModalDescription: a
}) => {
  const { t: o } = x();
  return /* @__PURE__ */ h(
    y,
    {
      backdropDismiss: !0,
      label: s == null ? void 0 : s.value,
      size: "medium",
      active: e,
      onNeuDismiss: t,
      children: [
        /* @__PURE__ */ n(y.Content, { children: /* @__PURE__ */ n(q, { field: a }) }),
        /* @__PURE__ */ n(y.Footer, { children: /* @__PURE__ */ n(L, { onNeuClick: t, className: "w-100 w-sm-auto", children: o("Mho.Profie.ManageRelationshipsProxy.Labels.Close") }) })
      ]
    }
  );
}, ze = ({
  proxyModalTitle: e,
  relationship: { firstName: t, lastName: s, myHealthOneId: a },
  isSupportConsole: o = !1,
  isEmulating: f = !1
}) => {
  const [u, c] = A(!1), { t: m } = x(), i = S(() => c(!0), []), d = S(() => c(!1), []), p = D(
    () => /* @__PURE__ */ n(L, { kind: "tertiary", size: "small", onNeuClick: i, children: m("Mho.Profie.ManageRelationshipsProxy.Labels.ManageCare") }),
    [m, i]
  ), g = `${t} ${s}`;
  return /* @__PURE__ */ h(B, { children: [
    /* @__PURE__ */ n(
      w.Item,
      {
        itemText1: g,
        customButton: o || f ? void 0 : p
      }
    ),
    /* @__PURE__ */ n(
      $e,
      {
        name: g,
        title: e == null ? void 0 : e.value,
        mhoId: a,
        isOpen: u,
        close: d
      }
    )
  ] });
}, He = (e) => {
  const t = Q();
  return K({
    ...e,
    onSuccess: (...s) => {
      t.invalidateQueries({ queryKey: V.user("FULL") }), t.invalidateQueries({ queryKey: V.userRelationships }), typeof (e == null ? void 0 : e.onSuccess) == "function" && e.onSuccess(...s);
    },
    mutationFn: ve
  });
}, Ke = "_formItem_r52t0_1", se = {
  formItem: Ke
}, Qe = (e, t, s) => de({
  firstName: R().min(1, { message: e("Mho.PageContent.Profile.EmergencyContact.Validation.ValidFirstName") }).regex(z.name, {
    message: e("Mho.PageContent.Profile.EmergencyContact.Validation.ValidFirstName")
  }),
  lastName: R().min(1, { message: e("Mho.PageContent.Profile.EmergencyContact.Validation.ValidLastName") }).regex(z.name, {
    message: e("Mho.PageContent.Profile.EmergencyContact.Validation.ValidLastName")
  }),
  relationType: R().min(1, {
    message: e("Mho.PageContent.Profile.EmergencyContact.Validation.ValidRelationshipPatient")
  }),
  dateOfBirth: R().min(1, { message: e("Mho.PageContent.Profile.EmergencyContact.Validation.ValidDate") }).refine((a) => a >= t && a <= s, {
    message: e("Mho.PageContent.Profile.EmergencyContact.Validation.ValidDate")
  }),
  phone: R().refine((a) => a.length === 13 && z.phone.test(a), {
    message: e("Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorPhoneValidation")
  }),
  phoneType: R().min(1, {
    message: e("Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorValidPhoneType")
  })
});
function Ye() {
  const e = /* @__PURE__ */ new Date(), t = new Date(e.getFullYear() - 13, e.getMonth(), e.getDate());
  return { min: "1900-01-01", max: ke(t.toISOString(), "yyyy-MM-dd") ?? "" };
}
function je(e) {
  const t = e == null ? void 0 : e.split("-");
  return [...t.slice(1), t[0]].join("/");
}
const We = ({
  newRelationshipModalTitle: e,
  newRelationshipModalDescription: t,
  mhoId: s,
  onSuccessfulAdd: a
}) => {
  const { t: o } = x(), { min: f, max: u } = D(() => Ye(), []), c = S(() => Qe(o, f, u), [o, f, u]), [m, i] = A(!1), d = S(() => i(!0), []), p = S(() => i(!1), []), g = Re({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      relationType: "",
      dateOfBirth: "",
      phone: "",
      phoneType: ""
    },
    resolver: he(c())
  }), {
    reset: b,
    watch: P,
    formState: { errors: l }
  } = g, N = !!(l != null && l.phone) || Ne(P("phone")), { data: E } = Ae(), { mutate: O, isPending: I, isError: T } = He({
    onSuccess: () => {
      Ee(s), a(), p(), b();
    }
  }), _ = S(
    async (k) => {
      const { dateOfBirth: U } = k;
      O({ ...k, dateOfBirth: je(U) });
    },
    [O]
  ), F = () => {
    p(), b();
  };
  return /* @__PURE__ */ h(B, { children: [
    /* @__PURE__ */ n(
      w.AddButton,
      {
        onClick: d,
        text: o("Mho.Profie.ManageRelationshipsProxy.Labels.AddNewRelationship")
      }
    ),
    /* @__PURE__ */ n(
      y,
      {
        backdropDismiss: !1,
        label: (e == null ? void 0 : e.value) ?? "",
        size: "medium",
        active: m,
        onNeuDismiss: F,
        children: /* @__PURE__ */ n(y.Content, { children: I ? /* @__PURE__ */ n(H, { kind: "spinner", size: "small" }) : /* @__PURE__ */ h("div", { className: "position-relative", children: [
          T && // TODO: Get error messages from sitecore fields or dictionary
          /* @__PURE__ */ n(
            Pe,
            {
              kind: "error",
              label: "Unable to add relationship",
              className: "mb-3",
              children: /* @__PURE__ */ n("p", { children: "Something went wrong could not add relationship. Please try again another time." })
            }
          ),
          /* @__PURE__ */ n(q, { field: t, className: "mb-3" }),
          /* @__PURE__ */ h(
            v,
            {
              methods: g,
              onSubmit: _,
              rowGap: 4,
              className: "row-gap-sm-3",
              submitButtonText: o("Mho.Profie.ManageRelationshipsProxy.Labels.Save"),
              cancelButtonText: o("Mho.Profie.ManageRelationshipsProxy.Labels.Close"),
              onCancel: F,
              isSubmitDisabled: I,
              buttonsAlignment: "end",
              padding: "px-0",
              children: [
                /* @__PURE__ */ h(v.Row, { columnGap: 3, className: "row-gap-4", children: [
                  /* @__PURE__ */ n(
                    ne,
                    {
                      name: "firstName",
                      label: o("Mho.PageContent.Profile.EmergencyContact.Label.FirstName"),
                      required: !0
                    }
                  ),
                  /* @__PURE__ */ n(
                    ne,
                    {
                      name: "lastName",
                      label: o("Mho.PageContent.Profile.EmergencyContact.Label.LastName"),
                      required: !0
                    }
                  )
                ] }),
                /* @__PURE__ */ n(v.Row, { children: /* @__PURE__ */ n(
                  te,
                  {
                    name: "relationType",
                    label: o("Mho.Profie.ManageRelationshipsProxy.Labels.RelationshipToPatient"),
                    required: !0,
                    items: E ?? []
                  }
                ) }),
                /* @__PURE__ */ n(v.Row, { children: /* @__PURE__ */ n(
                  Fe,
                  {
                    name: "dateOfBirth",
                    label: o("Mho.PageContent.Profile.EmergencyContact.Label.DateOfBirth"),
                    required: !0,
                    min: f,
                    max: u,
                    placeholder: o(
                      "Mho.PageContent.Profile.EmergencyContact.Label.DateOfBirthPlaceholder"
                    )
                  }
                ) }),
                /* @__PURE__ */ h(v.Row, { columnGap: 3, className: "row-gap-4", children: [
                  /* @__PURE__ */ n("div", { className: se.formItem, children: /* @__PURE__ */ n(
                    we,
                    {
                      name: "phone",
                      format: "phone",
                      label: o("Mho.PageContent.Profile.EmergencyContact.Label.PrimaryPhone"),
                      required: !0
                    }
                  ) }),
                  /* @__PURE__ */ n("div", { className: se.formItem, children: /* @__PURE__ */ n(
                    te,
                    {
                      name: "phoneType",
                      label: o("Mho.PageContent.Profile.EmergencyContact.Label.PhoneType"),
                      required: !0,
                      disabled: N,
                      items: Oe
                    }
                  ) })
                ] })
              ]
            }
          )
        ] }) })
      }
    )
  ] });
}, Xe = (e) => {
  const t = Q();
  return K({
    ...e,
    onSettled: (...s) => {
      typeof (e == null ? void 0 : e.onSettled) == "function" && e.onSettled(...s);
    },
    onSuccess: (...s) => {
      t.invalidateQueries({ queryKey: V.user("FULL") }), t.invalidateQueries({ queryKey: V.userRelationships }), typeof (e == null ? void 0 : e.onSuccess) == "function" && e.onSuccess(...s);
    },
    mutationFn: De
  });
}, Je = ({
  heading: e,
  fullName: t,
  description: s,
  relationshipId: a,
  isOpen: o,
  onSuccessfulDelete: f,
  onFailedDelete: u,
  closeModal: c
}) => {
  const { t: m } = x(), { mutate: i } = Xe({
    onSuccess: () => f(),
    onError: (p) => u((p == null ? void 0 : p.toString()) || m("Mho.FormValidations.FailedToSave"))
  }), d = () => {
    u(null), c(), i(a);
  };
  return /* @__PURE__ */ h(
    y,
    {
      label: e,
      active: o,
      backdropDismiss: !0,
      size: "large",
      onNeuDismiss: c,
      children: [
        /* @__PURE__ */ h(y.Content, { children: [
          /* @__PURE__ */ n("h2", { className: "neu-display-6 mb-1", children: t }),
          /* @__PURE__ */ n(Se, { tag: "p", field: s })
        ] }),
        /* @__PURE__ */ n(y.Footer, { children: /* @__PURE__ */ n(
          Te,
          {
            buttonsAlignment: "end",
            primaryText: m("Mho.PageContent.Messages.YesCta"),
            onPrimaryClick: d,
            secondaryText: m("Mho.PageContent.ManageRelationship.Cancel"),
            onSecondaryClick: c
          }
        ) })
      ]
    }
  );
}, Ze = ({
  id: e,
  firstName: t,
  lastName: s,
  relationType: a,
  username: o,
  removeRelationshipModalTitle: f,
  removeRelationshipModalDescription: u,
  detailPageLink: c,
  onSuccessfulDelete: m,
  onFailedDelete: i
}) => {
  const d = re(), {
    isOpen: p,
    openModal: g,
    closeModal: b
  } = Be(), P = D(() => {
    const l = a == null ? void 0 : a.toLowerCase().replace("_", " ");
    return (l == null ? void 0 : l.charAt(0).toUpperCase()) + (l == null ? void 0 : l.slice(1));
  }, [a]);
  return /* @__PURE__ */ h(B, { children: [
    /* @__PURE__ */ n(
      w.Item,
      {
        itemText1: `${t} ${s}`,
        itemSubText: P,
        onEditButtonClick: () => {
          var l;
          typeof window < "u" && (window.sessionStorage.setItem("connectedRelUsername", o), window.sessionStorage.setItem("connectedRelId", e.toString())), d.push({
            pathname: ((l = c == null ? void 0 : c.value) == null ? void 0 : l.href) || "",
            query: { tab: "General Information" }
          });
        },
        onDeleteButtonClick: g
      }
    ),
    /* @__PURE__ */ n(
      Je,
      {
        isOpen: p,
        closeModal: b,
        relationshipId: e,
        heading: (f == null ? void 0 : f.value) || "Delete Relationship",
        fullName: `${t} ${s}`,
        description: u,
        onSuccessfulDelete: m,
        onFailedDelete: i
      }
    )
  ] });
}, en = ({
  fields: {
    title: e,
    proxyRelationshipsTitle: t,
    proxyRelationshipsDescription: s,
    connectRelationshipsTitle: a,
    connectRelationshipsDescription: o,
    infoModalTitle: f,
    infoModalDescription: u,
    proxyModalTitle: c,
    newRelationshipModalTitle: m,
    newRelationshipModalDescription: i,
    isSupportConsole: d,
    removeRelationshipModalTitle: p,
    removeRelationshipModalDescription: g,
    detailsPageLink: b,
    learnMoreLinkText: P
  },
  rendering: { componentName: l }
}) => {
  var X, J;
  const N = ge(), E = (d == null ? void 0 : d.value) || !1, O = E ? !N : !1, I = oe(), [T, _] = A(null), { t: F } = x(), { snackbarProps: k, showSnackbar: U } = fe(), {
    data: r,
    error: $,
    isFetching: ie,
    isLoading: le
  } = ae({
    queryParams: { levelOfDetail: "FULL" },
    enabled: E ? N : !0
  }), Y = ((X = r == null ? void 0 : r.user) == null ? void 0 : X.myHealthOneId) || "", [ce, j] = A(!1), W = D(() => r != null && r.dependentRelationships ? [...r.dependentRelationships].sort(
    (C, M) => new Date(M.createdTs).getTime() - new Date(C.createdTs).getTime()
  ) : [], [r == null ? void 0 : r.dependentRelationships]), G = S(() => {
    U(
      F("Mho.Profile.ProfileGeneralInformation.PersonalSection.ProfileSuccessfullyChanged")
    );
  }, []), me = D(() => {
    var C, M;
    return (C = r == null ? void 0 : r.dependentRelationships) != null && C.length && ((M = r == null ? void 0 : r.dependentRelationships) == null ? void 0 : M.length) >= pe ? null : /* @__PURE__ */ n(
      We,
      {
        newRelationshipModalTitle: m,
        newRelationshipModalDescription: i,
        mhoId: Y,
        onSuccessfulAdd: G
      }
    );
  }, [
    (J = r == null ? void 0 : r.dependentRelationships) == null ? void 0 : J.length,
    m,
    i,
    Y,
    G
  ]);
  return _e(r), le ? /* @__PURE__ */ n(ee, { className: "p-3", children: /* @__PURE__ */ n(H, { kind: "spinner", color: "blue", size: "large", className: "mt-5 mb-5" }) }) : /* @__PURE__ */ n(ee, { className: "p-3", children: /* @__PURE__ */ h(
    Me,
    {
      componentName: l,
      level: "2",
      titleClassName: "neu-display-3 fw-bold",
      titleText: e == null ? void 0 : e.value,
      errorMessage: ($ == null ? void 0 : $.toString()) || T,
      errorDisplayDurationInSeconds: 10,
      children: [
        /* @__PURE__ */ n("div", { className: "mb-5", children: /* @__PURE__ */ h(
          w,
          {
            headerText1: t.value,
            descriptionContent: /* @__PURE__ */ h(B, { children: [
              /* @__PURE__ */ n(q, { field: s, tag: "span" }),
              /* @__PURE__ */ n(be, { onClick: () => j(!0), className: "p-0", children: P == null ? void 0 : P.value })
            ] }),
            descriptionCellSpan: 2,
            children: [
              /* @__PURE__ */ n(
                Ge,
                {
                  isOpen: ce,
                  onClose: () => j(!1),
                  infoModalTitle: f,
                  infoModalDescription: u
                }
              ),
              (r == null ? void 0 : r.caregiverRelationships) && r.caregiverRelationships.map((C) => {
                var M;
                return /* @__PURE__ */ n(
                  ze,
                  {
                    proxyModalTitle: c,
                    relationship: C,
                    isSupportConsole: E,
                    isEmulating: !!((M = I == null ? void 0 : I.emulation) != null && M.isEmulating)
                  },
                  C.id
                );
              })
            ]
          }
        ) }),
        ie || O ? /* @__PURE__ */ n(H, { kind: "spinner", className: "px-6 py-4" }) : /* @__PURE__ */ n(
          w,
          {
            headerText1: a == null ? void 0 : a.value,
            descriptionContent: /* @__PURE__ */ n(q, { field: o }),
            descriptionCellSpan: 2,
            footerComponent: me,
            children: W && W.map((C) => /* @__PURE__ */ n(
              Ze,
              {
                ...C,
                removeRelationshipModalTitle: p,
                removeRelationshipModalDescription: g,
                onSuccessfulDelete: G,
                onFailedDelete: _,
                detailPageLink: b
              },
              C.id
            ))
          }
        ),
        /* @__PURE__ */ n(Ce, { ...k })
      ]
    }
  ) });
}, vn = Ie()(
  en
);
export {
  vn as MhoManageRelationshipsProxy
};
